import { useAppSelector } from './useAppSelector'

export const useParticipantLabels = () =>
  useAppSelector((state) => state.participantLabels)